module.exports = __webpack_public_path__ + "static/potion_of_healing-5c42daa5aae4d30ca4dd30f06cf97df0.jpg";